import { Button, Chip, Divider, MenuItem } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import RoomIcon from '@material-ui/icons/Room';
import {
  getInfosIndividual,
  interestLevelOffer,
  interestLevelTraining,
} from '@webapps/business';
import {
  TextField,
  useMutation,
  useQuery,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarStudent from 'components/Avatar/AvatarStudent';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

const INTEREST_LEVEL = [
  { label: 'Neutre', value: 1 },
  { label: 'Faible', value: 2 },
  { label: 'Moyen', value: 3 },
  { label: 'Elevé', value: 4 },
];

const ProfilName = ({ id, info, level, idTraining, idOffer, refetch, refetchDashboardInfo, candidatureResponse, candidatureRead, rejectCandidature, acceptCandidature }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { fontSizes, spacing },
  } = useStyles(styles);

  const userid = info.id;
  const { addToast } = useToast();
  const [candidatureResponseState, setCandidatureResponseState] = useState(candidatureResponse);
  const [candidatureReadState, setCandidatureReadState] = useState(candidatureRead);

  const { data: profilInfo = [] } = useQuery(getInfosIndividual, {
    key: ['profilInfo', userid],
    variables: { id: userid },
    enabled: typeof userid !== 'undefined',
  });

  const { isSuccess: isSuccessSetInterestTraining, mutateAsync: mutateSetInterest } = useMutation(interestLevelTraining);
  
  const { isSuccess: isSuccessSetInterestOffer, mutateAsync: mutateSetInterestOffer } = useMutation(interestLevelOffer);

  const handleInterestTraining = async (event) => {
    await mutateSetInterest({
      applicantId: userid,
      level: event.target.value,
      trainingId: idTraining,
    });

    setCandidatureReadState(true);
    await refetchDashboardInfo();
  };

  const handleInterestOffer = async (event) => {
    await mutateSetInterestOffer({
      applicantId: userid,
      level: event.target.value,
      offerId: idOffer,
    });

    setCandidatureReadState(true);
    await refetchDashboardInfo();
  }

  const handleAccept = async (idCandidature) => {
    await acceptCandidature(id, idCandidature);
    setCandidatureResponseState('ACCEPTED');
  };

  const handleReject = async (idCandidature) => {
    await rejectCandidature(id, idCandidature);
    setCandidatureResponseState('REJECTED');
  };

  useEffect(() => {
    if (isSuccessSetInterestTraining || isSuccessSetInterestOffer) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      refetch();
    }
  }, [isSuccessSetInterestTraining, isSuccessSetInterestOffer]);

  const getStatusChip = (status) => {
    switch (status) {
      case 'PENDING':
        return <Chip classes={{ colorPrimary: css({ background: '#FAE8D7', color: '#FA8100' }) }}
          className={classes.chip}
          color="primary"
          label="Statut: En attente"
          size="small" />
      case 'ACCEPTED':
        return <Chip classes={{ colorPrimary: css({ background: '#DBFAD8', color: '#008000' }) }}
          className={classes.chip}
          color="primary"
          label="Statut: Accepté"
          size="small" />
      default:
        return <Chip classes={{ colorPrimary: css({ background: '#FBD3D5', color: '#F50057' }) }}
          className={classes.chip}
          color="primary"
          label="Statut: Refusé"
          size="small" />
    }
  };

  return (
    <div className={classes.container}>
      <Grid className={classes.LabelContainer} container >
        <Grid className={css({ display: 'flex' })} item xs={12}>
          <div className={classes.interestSelect}>
            <div className={cx(global.title, classes.title)}>
              Etat de la candidature
            </div>

            <div className={classes.row}>
              <div>
                {getStatusChip(candidatureResponseState)}
              </div>

              <div >
                {candidatureReadState ?
                  <Chip
                    classes={{
                      colorPrimary: css({
                        background: '#DBFAD8',
                        color: '#008000',
                      }),
                    }}
                    className={classes.chip}
                    color="primary"
                    label="Profil: Examiné"
                    size="small"
                  />
                  :
                  <Chip
                    classes={{
                      colorPrimary: css({
                        background: '#F3F7FF',
                        color: '#5D75A8',
                      }),
                    }}
                    className={classes.chip}
                    color="primary"
                    label="Profil: Non examiné"
                    size="small"
                  />
                }
              </div>
            </div>
            <TextField
              defaultValue={level}
              fullWidth
              fullHeight={false}
              label="Niveau d'intérêt"
              name="interest"
              onChange={(e) => {idOffer ? handleInterestOffer(e) : handleInterestTraining(e)}}
              select
            >
              {INTEREST_LEVEL.map(({ label, value }, index) => (
                <MenuItem key={index} value={value}>
                  {label}
                </MenuItem>
              ))}
            </TextField>
            <Grid container spacing={2} className={css({ marginTop: spacing(2) })}>
            {candidatureResponseState === 'PENDING' && (
              <>
                <Grid item xs={6}>
                  <Button
                    fullWidth
                    className={css({ backgroundColor: '#C0D9FF' })}
                    onClick={() => {idOffer ? handleAccept(idOffer) : handleAccept(idTraining)}}
                    variant="outlined"
                    color="primary"
                    disableElevation
                  >
                    Accepter
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    fullWidth
                    className={css({ backgroundColor: '#FBD3D5' })}
                    onClick={() => {idOffer ? handleReject(idOffer) : handleReject(idTraining)}}
                    variant="outlined"
                    color="secondary"
                    disableElevation
                  >
                    Refuser
                  </Button>
                </Grid>
              </>
              )}
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

const styles = ({ fontSizes, spacing }) => ({
  container: {
    borderRadius: 10,
    padding: spacing(0, 2.5),
    display: 'flex',
    flexDirection: 'column',
    marginTop: spacing(2.5),
  },
  containerInfo: {
    paddingBottom: spacing(2.5),
    // background: 'red',
  },
  title: {
    borderLeft: '3px solid #0060F9',
    lineHeight: '100%',
    paddingLeft: spacing(1),
    marginBottom: spacing(1.5),
  },
  avatar: {
    height: 70,
    width: 70,
  },
  nameContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    marginLeft: spacing(1),
  },
  gridBtn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  favBtn: {
    textAlign: 'right',
  },
  ButtonContainer: {
    paddingTop: spacing(2.5),
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    marginTop: spacing(0.5),
  },
  chip: {
    padding: spacing(2.5),
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 'regular',
    marginTop: '4px',
    borderRadius: '10.0px',
    '@media only screen and (max-width:768px)': { padding: spacing(2) },
  },
  interestSelect: {
    width: '100%',
    marginLeft: spacing(0),
    '@media (max-width:768px)': { width: '50%' }
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(2, 1),
    marginBottom: spacing(3),
  },
});

ProfilName.propTypes = {
  info: PropTypes.object,
  offerId: PropTypes.string,
  level: PropTypes.number,
  refetch: PropTypes.func,
};

export default ProfilName;
